import React from 'react';

const QuoteHero: React.FC = () => {
  return (
    <section className="relative w-full py-12 px-4 flex justify-center bg-[#010712]">
      <div className="relative w-full max-w-[1440px] h-[50vh] min-h-[400px] flex items-center overflow-hidden bg-[#0a1220]/40 rounded-none shadow-[0_20px_50px_rgba(0,0,0,0.6)]">
        {/* Subtle industrial background texture */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-10 mix-blend-overlay"
          style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1574689232449-3e67ae143a75?q=80&w=2070&auto=format&fit=crop")' }}
        />
        <div className="absolute inset-0 bg-[#020712]/40 backdrop-blur-sm" />
        
        {/* Decorative elements */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#C5A059]/5 blur-[100px] rounded-full pointer-events-none" />

        {/* Content */}
        <div className="relative w-full px-8 md:px-16 z-10 text-center md:text-left">
          <div className="max-w-4xl mx-auto md:mx-0">
            <blockquote className="text-3xl md:text-5xl lg:text-6xl font-medium text-white mb-8 leading-[1.1] tracking-tighter">
              Capital doesn’t flow to potential. <br />
              It flows to <span className="bg-[linear-gradient(to_right,#C5A059_0%,#E6C587_25%,#FFF2D4_50%,#E6C587_75%,#C5A059_100%)] bg-clip-text text-transparent animate-gold-shimmer font-bold">clarity, credibility, and structure.</span>
            </blockquote>
            <div className="h-[2px] w-24 bg-[#C5A059] mb-6 hidden md:block rounded-full" />
            <p className="text-[#8e8e93] text-[13px] md:text-[14px] font-bold uppercase tracking-[0.3em]">
              That’s the gap we fix.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteHero;
